import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { SentimentLegendItem, DEFAULT_SENTIMENT_LEGEND_ITEMS, SENTIMENT_LABEL_KEY_MAP, SENTIMENT_ICON_BASE_PATH, SENTIMENT_ICON_MAP } from './sentiment-legend.model';
@Component({
    selector: 'cv-sentiment-legend',
    templateUrl: './sentiment-legend.component.html',
    styleUrls: ['./sentiment-legend.component.scss']
})
export class SentimentLegendComponent implements OnInit {
    @Input() title: string;
    @Input() legendItems: SentimentLegendItem[] = [];
    @Input() showToggle: boolean;
    @Input() toggleLabel: string;
    @Input() toggleStatus: boolean;
    @Input() isHidden: boolean;
    @Output() toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private cvLocalizationService: CVLocalizationService) { }

    async ngOnInit(): Promise<void> {
        await this.cvLocalizationService.GetSection("CXOne_Sentiment_Legend");

        if (this.legendItems.length === 0) {
            this.legendItems = DEFAULT_SENTIMENT_LEGEND_ITEMS;
        }
    }

    onToggleChange(value: boolean): void {
        this.toggleStatus = value;
        this.toggleChange.emit(this.toggleStatus);
    }

    getSentimentIcon(label: string): string | null {
        return SENTIMENT_ICON_MAP[label] ? `${SENTIMENT_ICON_BASE_PATH}${SENTIMENT_ICON_MAP[label]}` : null;
    }

    getSentimentIconStyle(label: string): any {
        const blackFillLabels = ['Moderately Negative', 'Neutral', 'Moderately Positive'];
        return blackFillLabels.includes(label) ?
            { 'filter': 'brightness(0)' } :
            { 'filter': 'none' };
    }

    get toggleStatusText(): string {
        return this.toggleStatus
            ? this.cvLocalizationService.getCachedText("CXOne_Sentiment_Legend", "Toggle_On", "On")
            : this.cvLocalizationService.getCachedText("CXOne_Sentiment_Legend", "Toggle_Off", "Off");
    }

    getLocalizedLabel(label: string): string {
        const key = SENTIMENT_LABEL_KEY_MAP[label] || label.replace(/\s+/g, '_');
        return this.cvLocalizationService.getCachedText("CXOne_Sentiment_Legend", key, label);
    }
}
